/**
 * PD-17809 — where a page opened on a brand's meeting address belongs, or null when it can
 * stay. That address is served by the same bundle as the store, so it answers every store
 * path too; without this, meet.acme.com would show the store, sign people in and collect
 * carts on an address that exists only for booking links.
 */
export function storeUrlForMeetingAddress(input: {
	hostname: string;
	pathname: string;
	search: string;
	meetingHostname: string | null | undefined;
	canonicalOrigin: string | undefined;
}): string | null {
	const { hostname, pathname, search, meetingHostname, canonicalOrigin } = input;

	if (
		meetingHostname == null ||
		canonicalOrigin == null ||
		hostname.toLowerCase() !== meetingHostname.toLowerCase()
	) {
		return null;
	}

	if (pathname === '/book' || pathname.startsWith('/book/')) {
		return null;
	}

	return `${canonicalOrigin}${pathname}${search}`;
}
